import React from 'react';
import { Container, Box, StatusIndicator, SpaceBetween } from '@cloudscape-design/components';

const ValidationSummaryBanner = ({ label, validationData }) => {
  if (!validationData || Object.keys(validationData).length === 0) {
    return null;
  }

  const { result, status, reason, sop_sections } = validationData;

  // Determine StatusIndicator type based on result
  const getStatusType = () => {
    if (status === 'not_applicable' || status === 'not_run') return 'stopped';
    if (status === 'invalid_account_id_warning') return 'warning';
    if (result === 'pass') return 'success';
    if (result === 'fail') return 'error';
    if (result === 'needs_attention') return 'warning';
    return 'info';
  };

  // Override reason text for known warning statuses that have updated messaging
  const getDisplayReason = () => {
    if (status === 'invalid_account_id_warning') {
      const accountIdMatch = reason?.match(/(\d{12})/);
      const accountId = accountIdMatch ? accountIdMatch[1] : '000000000000';
      return `Warning: The AWS Account ID provided (${accountId}) is not valid. While this requires attention before project completion, no immediate action is needed at the Assess phase.`;
    }
    return reason;
  };

  // Format status for display
  const formatStatus = (status) => {
    if (!status) return 'UNKNOWN';
    return status.toUpperCase().replace(/_/g, ' ');
  };

  // Format SOP sections
  const sopText = sop_sections && sop_sections.length > 0 
    ? `SOP ${sop_sections.join(', ')}` 
    : '';

  return (
    <Box padding={{ vertical: 'xs' }}>
      <Box fontSize="heading-s" fontWeight="bold">
        <StatusIndicator type={getStatusType()}>
          {formatStatus(status)}
        </StatusIndicator>
      </Box>
      {reason && (
        <Box fontSize="body-m" color="text-body-secondary" padding={{ top: 'xxs' }}>
          {getDisplayReason()}
        </Box>
      )}
    </Box>
  );
};

export default ValidationSummaryBanner;
